

var urlParam = (function(){
    var getobj = {};
    var regExpobj = new RegExp(/&([^=|.])*=/g);
    var searchUrl = "&" + location.search.substring("1");
    var keyArr = searchUrl.match(regExpobj) || [];
    var valueArr = searchUrl.replace(regExpobj,'&&&').split('&&&');
    valueArr.shift();
    // keyArr.forEach(function(item,index){
    //     getobj[item.substring(1,item.length-1)] = decodeURIComponent(valueArr[index]);
    // })
    // ie8不支持forEach，改成for循环
    for(var i = 0; i < keyArr.length; i++) {
        var item = keyArr[i];
        getobj[item.substring(1,item.length-1)] = decodeURIComponent(valueArr[i]);
    }
    return getobj;
})();

export default urlParam

